import { getMunData } from "utils"

const data = getMunData()

const detailEnglish = {
    nrs: "NRs.",
    estimatedBudget: "ESTIMATED BUDGET",
    allocatedBudget: "ALLOCATED BUDGET",
    agreementAmount: "AGREEMENT AMOUNT",
    userCommitteeContribution: "USER COMMITTEE CONTRIBUTION",
    wards: "WARDS",
    totalBidders: "TOTAL BIDDERS",
    nameOfContractor: "NAME OF CONTRACTOR",
    nameOfUserCommittee: "Name of user committee",
    feedback: "Feedback for this project",
    monitoring: "Monitoring for this project",
    backToProjects: "Back to projects",
    actualStartDate: "ACTUAL START DATE",
    agreementDate: "AGREEMENT DATE",
    completionDate: "COMPLETION DATE",
    projectTimeline: "project timeline",
    daysLateState: "days late start",
    userCommitteeOfficials: "User committee officials",
    position: "Position",
    name: "Name",
    address: "Address",
    mobile: "Mobile",
    FeedbackAbout: "About Feedback",
    nofeedback: "No feedback has been posted for this project yet.",
    nomonitoring: "No progress has been posted for this project yet.",
    downloadOurApp:
        "Download our app to provide feedback for this and other projects.",
    gotFeedback: "Got feedback for this project? ",
    downloadAndroid: "Download our Android app and join the conversation.",
    feedbackText:
        "Your feedback helps in the collection of factual information regarding the progress of a project. You can easily use this system by downloading the app in your andriod phone by following these steps:",
    feedbackStep1: `Go to Google Playstore and download the Infrastructure Management System (${
        data.contact_en.region
    }) app in your android phone.`,
    feedbackStep2num: "2",
    feedbackStep2:
        "You can see the list of the projects, there statuses as well as their physical and financial progress. Please tap the project that you want to provide feedback . Then press Give Feedback .",
    feedbackStep3num: "3",
    feedbackStep3:
        "You can give feedback to various issues of the projects. You can also send the photo through the app to establish your concern.",
    projectNameInNepali: 'Project Name (in Nepali)',
    projectNameInEnglish: 'Project Name (in English)',
    typeOfProject: 'Type of Project',
    typeOfRoadProject: 'Type of Road Project',
    roadLength: 'Road Length (Mtr.)',
    bridgeLength: 'Bridge Length (Mtr.)',
    wardWhereTheProjectWillBeImplemented: 'Ward where the project will be implemented',
    durationOfProject: 'Duration of Project',
    estimatedCostForTheProject: 'Estimated cost for the project (NPR)',
    implementationModel: 'Implementation Model',
    uploadedWardOfficeDocument: 'Uploaded Ward Office Document',
    status: 'Status',
    month: "Month",
    months: "Months",
}

const detailNepali = {
    nrs: "नेरु.",
    estimatedBudget: "अनुमानित लागत",
    allocatedBudget: "विनियोजित बजेट",
    agreementAmount: "सम्झौता रकम",
    userCommitteeContribution: "उपभोक्ता समिति (योगदान)",
    wards: "वडाहरू",
    totalBidders: "कुल बोलपत्रदाताहरू",
    nameOfContractor: "निर्माण व्यवसायीकाे नाम",
    nameOfUserCommittee: "उपभाेक्ता समितिकाे नाम",
    feedback: "प्रतिक्रियाहरु",
    monitoring: "प्रगति अवस्थाहरु",
    backToProjects: "परियाेजनामा फिर्ता",
    actualStartDate: "बास्तविक सुरु मिति",
    agreementDate: "सम्झौता भएकाे मिति",
    completionDate: "सम्पन्न मिति",
    projectTimeline: "परियाेजनाकाे समयरेखा",
    daysLateState: "दिन ढिला सुरु भएकाे",
    userCommitteeOfficials: "उपभोक्ता समितिका पदाधिकारी",
    position: "पद",
    name: "नाम",
    address: "सम्पर्क",
    mobile: "मोबाइल",
    FeedbackAbout: "प्रतिकृयाका बारेमा",
    nofeedback: "यस परियाेजनामा हालसम्म कुनै पनि प्रतिकृया दिइएकाे छैन ।",
    nomonitoring: "यस परियाेजनामा हालसम्म कुनै पनि प्रगति अवस्थाहरु दिइएकाे छैन ।",
    downloadOurApp:
        "यस परियाेजना एवं अन्य परियाेजनामा प्रतिकृया दिनका लागि हाम्राे एप डाउनलाेड गर्नुहाेस्।",
    gotFeedback: "यस परियाेजनामा प्रतिकृया प्राप्त भएकाे छ?",
    downloadAndroid: "हाम्राे एप डाउनलाेड गरी छलफलमा सहभागी हुनुहाेस्।",
    feedbackText:
        "तपाईकाे प्रतिकृयाबाट यस परियाेजनाकाे प्रगतिका सम्बन्धमा तथ्यमा आधारित जानकारी संकलन हुन्छ ।तपाईले आफ्नाे माेबाइल फाेनमा एप डाउनलाेड गरी सहज रुपमा यस प्रणालीकाे प्रयाेग गर्न सक्नुहुनेछ । ",
    feedbackStep1: `तपाईकाेे एन्ड्राेइड फाेनकाे गुगल प्लेस्टाेरमा गई Infrastructure Management System (${
        data.contact_en.region
    }) एप डाउनलाेड गर्नुहाेस् ।`,
    feedbackStep2num: "२",
    feedbackStep2:
        "उक्त एपमा तपाईले परियाेजनाहरुकाे सूचीका साथै साेकाे अवस्थाका साथसाथै भाैतिक एवं वित्तीय प्रगति देख्न सक्नुहुनेछ । तपाईलेे प्रतिकृया दिन चाहेकाे परियाेजनामा थिचि प्रतिकृया थप्नुहाेस् मा थिच्नुहाेस्।",
    feedbackStep3num: "३",
    feedbackStep3:
        "तपाईले परियाेजनाका विभिन्न विषयमा आफ्ना प्रतिकृया राख्न पाउनुहुन्छ । साथै आफ्नाे प्रतिकृयालाई प्रमाणित गर्नका लागि फाेटाे समेत खिचि साेही एपमार्फत पठाउन सक्नुहुनेछ । ",
    projectNameInNepali: 'परियोजनाको नाम (नेपालीमा)',
    projectNameInEnglish: 'परियोजनाको नाम (अंग्रेजीमा)',
    typeOfProject: 'परियोजनाको प्रकार',
    typeOfRoadProject: 'सडक परियोजनाको प्रकार',
    roadLength: 'सडक लम्बाई (मि.)',
    bridgeLength: 'पुलको लम्बाई (मि)',
    wardWhereTheProjectWillBeImplemented: 'योजना कार्यान्वयन हुने वडा',
    durationOfProject: 'परियोजनाको अवधी',
    estimatedCostForTheProject: 'परियोजनाको अनुमानित लागत (ने.रू)',
    implementationModel: 'कार्यान्वयनको ढाँचा',
    uploadedWardOfficeDocument: 'वडा कार्यालयको कागजात अपलोड गरिएको',
    status: 'स्थिति',
    month: "महिना",
    months: "महिना",
}

export {
    detailEnglish,
    detailNepali,
}



// WEBPACK FOOTER //
// ./src/localization/detail.js